<template>
  <el-card>
    <div slot="header">
      <div class="page-hedaer">
        <h4 class="page-title">提现列表</h4>
        <span class="title-info">(显示系统全部用户提现申请记录)</span>
      </div>
    </div>

    <!-- 筛选栏 -->
    <el-form :inline="true" class="filter-form">
      <el-form-item label="状态">
        <el-select
          size="small"
          v-model="filters.status"
          placeholder="请选择状态"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="申请中" value="pending"></el-option>
          <el-option label="已打款" value="completed"></el-option>
          <el-option label="拒绝提现" value="failed"></el-option>
          <el-option label="已退回" value="payback"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="fetchRecords(1)"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>

    <el-table :data="records" v-loading="loading" style="width: 100%">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column
        prop="phone"
        label="用户手机"
        width="120"
      ></el-table-column>
      <el-table-column prop="alipay_name" label="支付宝姓名"></el-table-column>
      <el-table-column
        prop="alipay_account"
        label="支付宝账号"
      ></el-table-column>
      <el-table-column prop="amount" label="提现金额">
        <template slot-scope="scope"
          >¥{{ fenToYuan(scope.row.amount) }}</template
        >
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">
            {{ getStatusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注">
        <template slot-scope="scope">
          {{ scope.row.remark || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="申请时间"
        width="170"
      ></el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status === 'pending'"
            size="mini"
            type="primary"
            @click="openEditDialog(scope.row)"
          >
            修改信息
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :current-page="page"
        :page-size="pageSize"
        @current-change="fetchRecords"
      />
    </div>

    <!-- 修改信息弹窗 -->
    <el-dialog title="修改提现信息" :visible.sync="dialogVisible" width="500px">
      <el-form label-width="80px">
        <el-form-item label="状态">
          <el-select
            v-model="editForm.status"
            placeholder="请选择状态"
            style="width: 100%"
          >
            <el-option label="提现成功" value="completed"></el-option>
            <el-option label="提现失败" value="failed"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="editForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveEdit">确定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import api from "../../api";

export default {
  name: "Withdrawals",
  data() {
    return {
      records: [],
      loading: false,
      total: 0,
      page: 1,
      pageSize: 20,
      dialogVisible: false,
      filters: {
        status: "pending",
      },
      editForm: {
        id: null,
        status: "completed",
        remark: "",
      },
    };
  },
  created() {
    this.fetchRecords();
  },
  methods: {
    async fetchRecords(page = 1) {
      this.page = page;
      this.loading = true;
      try {
        const params = { page, page_size: this.pageSize };
        if (this.filters.status) params.status = this.filters.status;

        const { data } = await api.get("/api/admin/withdrawals", { params });
        this.records = data.items || [];
        this.total = data.total || 0;
      } catch (e) {
        this.$message.error("获取提现记录失败");
      } finally {
        this.loading = false;
      }
    },
    fenToYuan(fen) {
      return ((fen || 0) / 100).toFixed(2);
    },
    getStatusType(status) {
      const map = {
        pending: "warning",
        completed: "success",
        failed: "danger",
        payback: "success",
      };
      return map[status] || "info";
    },
    getStatusText(status) {
      const map = {
        pending: "待打款",
        completed: "已打款",
        failed: "拒绝提现",
        payback: "已退还",
      };
      return map[status] || status;
    },
    openEditDialog(row) {
      this.editForm.id = row.id;
      this.editForm.remark = row.remark || "";
      this.dialogVisible = true;
    },
    async saveEdit() {
      try {
        await api.put(`/api/admin/withdrawals/${this.editForm.id}`, {
          status: this.editForm.status,
          remark: this.editForm.remark,
        });
        this.$message.success("修改成功");
        this.dialogVisible = false;
        this.fetchRecords(this.page);
      } catch (e) {
        this.$message.error("修改失败");
      }
    },
  },
};
</script>

<style scoped>
.page-hedaer{
  display: flex;
  align-items: center;
  min-height: 32px;
}
.page-title{
  margin: 0;
}
.title-info{
  margin-left: 5px;
  font-size: 12px;
  color:#909399;
}
.filter-form {
  margin-bottom: 20px;
}
.pager {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
